import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Valentines2022 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

    let designerLocationArray = [
    	{
				display: 'Select Location',
				value: '',
				dates: '',
				page: '',
			},
    	{
				display: 'Austin, TX',
				value: 'atx',
				dates: 'simong_11-13.png',
				page: 'austin',
			},
			{
				display: 'Birmingham, AL',
				value: 'bhm',
				dates: 'heera_11-12.png',
				page: 'birmingham',
			},
			{
				display: 'Boca Raton, FL',
				value: 'boc',
				dates: 'tacori.png',
				page: 'boca-raton',
			},
			{
				display: 'Charleston, SC',
				value: 'chs',
				dates: 'simong_11-13.png',
				page: 'charleston',
			},
			{
				display: 'Charlotte, NC',
				value: 'clt',
				dates: 'simong_11-13.png',
				page: 'charlotte',
			},
			{
				display: 'Cleveland, OH',
				value: 'cle',
				dates: 'fana_11-13.png',
				page: 'cleveland',
			},
			{
				display: 'Columbus, OH',
				value: 'coh',
				dates: 'ajaffe.png',
				page: 'columbus',
			},
			{
				display: 'Dallas, TX',
				value: 'dfw',
				dates: 'tacori.png',
				page: 'dallas',
			},
			{
				display: 'Frisco, TX',
				value: 'ftx',
				dates: 'tacori.png',
				page: 'frisco',
			},
			{
				display: 'Greenville, SC',
				value: 'gsc',
				dates: 'pejay.png',
				page: 'greenville',
			},
			{
				display: 'Houston, TX',
				value: 'hou',
				dates: 'uneek.png',
				page: 'houston',
			},
			{
				display: 'Indianapolis, IN',
				value: 'ind',
				dates: 'simong_11-13.png',
				page: 'indianapolis',
			},
			{
				display: 'Jacksonville, FL',
				value: 'jax',
				dates: 'simong_11-12.png',
				page: 'jacksonville',
			},
			{
				display: 'Kansas City, KS',
				value: 'kcy',
				dates: 'divine.png',
				page: 'kansas-city',
			},
			{
				display: 'New Orleans, LA',
				value: 'nol',
				dates: 'ajaffe.png',
				page: 'new-orleans',
			},
			{
				display: 'Oklahoma City, OK',
				value: 'okc',
				dates: 'fana_11-12.png',
				page: 'oklahoma-city',
			},
			{
				display: 'Pittsburgh, PA',
				value: 'pit',
				dates: 'ajaffe.png',
				page: 'pittsburgh',
			},
			{
				display: 'Raleigh, NC',
				value: 'ral',
				dates: 'amden.png',
				page: 'raleigh',
			},
			{
				display: 'Richmond, VA',
				value: 'rva',
				dates: 'simong_11-12.png',
				page: 'richmond',
			},
			{
				display: 'St. Louis, MO',
				value: 'stl',
				dates: 'ajaffe.png',
				page: 'st-louis',
			},
			{
				display: 'San Antonio, TX',
				value: 'san',
				dates: 'simong_11-13.png',
				page: 'san-antonio',
			},
			{
				display: 'Virginia Beach, VA',
				value: 'vab',
				dates: 'amden.png',
				page: 'virginia-beach',
			},
	  ];

		this.state = {
			
			locations: newArray,

			designerLocation: '',
			designerLocationArray: designerLocationArray,

			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesignerLocation: null,

			bgWidth: 0,
			bgHeight: 0,
		};

	}

  componentWillMount() {

  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	giftsNav() {
		window.location.href = 'https://gifts.diamondsdirect.com';
	}

	openIntercom() {
    acquireIO.max();
  }

	getLocationDesigners() {
		return [];
	}

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeDesigner(evt) {
		this.setState({ inputDesigner: evt.target.value });
	}

	changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = locationValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  getShowDates(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.dates;
  		}
  	}
  	return '';
  }

  getShowLink(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.page;
  		}
  	}
  	return '';
  }

  designerNav(page) {
  	if(!page) { return; }
  	this.internalNav(page);
  }

  changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	render() {

		return <div className='Valentines2022'>

			<img src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=lead&pixid=7333a400-055a-4ea4-a1b7-835149f34435" width="1" height="1" />

			<div className='headerSection'>
				<div className='headerSectionWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/dec_landing_banner.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/dec_landing_banner_m.jpg' />
				</div>
			</div>

			<div className='topSection'>
				<div className='topP'>This Valentine’s Day, give the one you love the gift that lets them feel your love forever!</div>
				<div className='topP'>Shop with us in-store or online and take advantage of:</div>
				<div className='boxSection'>
					<div className='fuBox'>
						<div className='box1'>0% APR for 5 Years<sup>1</sup></div>
						<div className='box2'>Subject to credit approval.</div>
						<div className='box3'>Now - Feb. 14</div>
						<div className='boxButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}><div>Ready to Apply</div></div>
					</div>
				</div>
				<div className={'topP darkBold'}>Enjoy Special Sunday Hours February 13th</div>
				<div className={'topP dark'}>11 a.m. - 4 p.m.</div>
				<div className='topGallery'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/editorial.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/editorial_m.jpg' />
					<div className={'ol ol1'} onClick={() => this.internalNav('setting/SMD1410732')}></div>
					<div className={'ol ol2'} onClick={() => this.internalNav('jewelry/BLDMD31653')}></div>
					<div className={'ol ol4'} onClick={() => this.internalNav('diamond-studs')}></div>
					<div className={'ol ol5'} onClick={() => this.internalNav('setting/SMD1444410')}></div>
				</div>
			</div>

			<div className='designersSection'>
				<div className='designersLeft'>
					<div className='designersTitle'>Exclusive Designer Trunk Shows</div>
					<div className='designersLine'>
						<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/trunkline.png' />
					</div>
					<div className='designersP'>Internationally renowned designers will be in-store; showcasing expanded, one-of-a-kind collections of fine jewelry.</div>
					<div className='designersP'>Select your Diamonds Direct location below to see which designers will be coming to your area!</div>
					<div className='designersSelectWrapper'>
						<RhinoSelect
							selectClass={'summerSelect'}
							value={this.state.designerLocation}
							options={this.state.designerLocationArray}
							changeMethod={(evt) => this.changeDesignerLocation(evt)} />
					</div>
					<div className='designerResultsWrapper'>
						{this.state.designerLocation && this.getShowDates(this.state.designerLocation) ?
							<div className='designerResultsDates'>
								<img src={`https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/${this.getShowDates(this.state.designerLocation)}`} />
							</div> :
							null
						}
					</div>
				</div>
			</div>

			<div className='formSection'>
				
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>
						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Full Name*'
									value={this.state.inputName}
                	onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email Address*'
									value={this.state.inputEmail}
                	onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Telephone'
									value={this.state.inputPhone}
                	onChange={::this.changePhone} />
							</div>
							<div className='formInputWrapper'>
								<RhinoSelect
	                selectClass={'summerSelect'}
	                required={true}
	                value={this.state.inputLocation}
	                options={this.state.locations}
	                changeMethod={(evt) => this.changeLocation(evt)}
	                error={this.state.errorLocation !== null} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='ggSection'>
				<div className='ggTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/gg.png' />
				</div>
				<div className='ggLine'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/valentines2022/landing/assets/ggline.png' />
				</div>
				<div className='ggP'>Diamonds Direct invites you to enjoy this Valentine's Day with a little extra sparkle!</div>
				<div className='ggP'>Shop our favorite gift guide items in our showrooms or from the comfort of your own home!</div>
				<div className='ggButton' onClick={::this.giftsNav}>Shop Valentine's Gifts</div>

				<div className='ggItemRow'>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/EHOOP05406')}>
						<div className={'ggItemImg ggItemImg1'}></div>
						<div className={'ggItemLabel'}>Tacori Diamond Crescent Hoop Earrings</div>
					</div>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/BLDXL19649')}>
						<div className={'ggItemImg ggItemImg2'}></div>
						<div className={'ggItemLabel'}>Emerald Diamond Eternity Band</div>
					</div>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/PBZ0200075')}>
						<div className={'ggItemImg ggItemImg3'}></div>
						<div className={'ggItemLabel'}>Diamond Bezel Solitaire Pendant</div>
					</div>
					<div className={'ggItem'} onClick={() => this.internalNav('jewelry/TBMIS05129')}>
						<div className={'ggItemImg ggItemImg4'}></div>
						<div className={'ggItemLabel'}>Pear Shape Diamond Tennis Bracelet</div>
					</div>
				</div>
			</div>
			
		</div>;
	}
}
export default Valentines2022;

function mapStateToProps(state) {
  return {

  };
}

export const Valentines2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Valentines2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/valentines2022/Valentines2022.jsx